<template lang="pug">
Erro(v-if='usuarioLogado && usuarioParceriaSustentavel')

#app(v-else-if='usuarioLogado')
    menu-lateral(v-if='showMenu', :botoes='botoes', :key='atualizarBotoes')

    menu-superior(
        v-if='showMenu',
        :route='this.$route.name',
        :routeParams='this.$route.params',
        @updateGrupoSelecionado='updateGrupoSelecionado'
    )

    section.conteudo-central
        router-view

    ExportarDocumentoVue
    ExportarDocumentoAnaliseCredito
    ModalDocumentosAssincronos(@reloadLaudoRenovabio='reloadLaudoRenovabio')

    ToastNotificationStack
    NotificationSidePanel

    Loading
</template>

<script>
import store from '@/store';
import { mapState } from 'vuex';

import MenuLateral from '@/components/layout/MenuLateral';
import MenuSuperior from '@/components/layout/MenuSuperior.vue';
import Loading from '@/components/Loading';
import ExportarDocumentoVue from '@/components/diagnosticoSocioambiental/ExportarDocumento';
import ExportarDocumentoAnaliseCredito from '@/components/preAnaliseCredito/ExportarDocumentoAnaliseCredito.vue';
import ModalDocumentosAssincronos from '@/components/laudos/renovabio/ModalDocumentosAssincronos.vue';
import ToastNotificationStack from '@/components/common/ToastNotificationStack.vue';
import NotificationSidePanel from '@/components/common/NotificationSidePanel.vue';
import Manutencao from '@/views/Manutencao.vue';
import authService from '@/services/AuthService';
import controleAcesso from '@/utils/controleAcesso';
import Temas from '@/utils/layouts/temas';
import Erro from '@/views/Erro.vue';
import MenuSuperiorTrilhaPssc from '@/components/pssc/trilha/MenuSuperiorTrilhaPssc.vue';
import { connect, disconnect, subscribeReports, subscribeNotifications } from '@/utils/websocket';
import ReportNotificationHandler from '@/services/notifications/ReportNotificationHandler';
import CadastroLoteNotificationHandler from '@/services/notifications/CadastroLoteNotificationHandler';

export default {
    name: 'app',
    components: {
        Erro,
        MenuSuperior,
        MenuLateral,
        Loading,
        ExportarDocumentoVue,
        ExportarDocumentoAnaliseCredito,
        ModalDocumentosAssincronos,
        ToastNotificationStack,
        NotificationSidePanel,
        Manutencao,
        MenuSuperiorTrilhaPssc
    },
    props: {
        keycloak: {
            type: Object,
            required: true
        },
        esconderMenus: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            botoes: [],
            atualizarBotoes: 0,
            showMenu: true,
            webSocketInitialized: false
        };
    },
    async created() {
        await this.buscarDadosUsuarioLogado();
    },
    mounted() {
        // Registra instância global para acesso do NotificationService
        window.app = this;

        // Inicializar WebSocket para notificações de relatórios
        this.initWebSocket();

        // Inicializar handler de notificações de relatórios
        ReportNotificationHandler.initializeReportListener();
        
        // Inicializar handler de notificações de cadastro em lote
        CadastroLoteNotificationHandler.initializeListener();

        if (this.esconderMenus) {
            this.showMenu = false;
            document
                .querySelectorAll('.menu-lateral, .header-container')
                .forEach(element => {
                    element.style.visibility = 'hidden';
                });

            document.querySelectorAll('.conteudo-central').forEach(element => {
                element.style.marginTop = '0px';
                element.style.marginLeft = '0px';
                element.style.height = '100vh';
                element.style.width = '100vw';
            });
        }
    },
    beforeDestroy() {
        // Desconectar WebSocket ao destruir componente
        disconnect();
        this.webSocketInitialized = false;
    },
    computed: {
        ...mapState(['usuarioLogado']),

        ano: function () {
            return new Date().getFullYear();
        },
        usuarioParceriaSustentavel: function () {
            return (
                this.usuarioLogado.attrGroupUser &&
                this.usuarioLogado.attrGroupUser.includes('BUNGE')
            );
        }
    },
    methods: {
        async buscarDadosUsuarioLogado() {
            const data = this.usuarioLogado;

            if (data === null) {
                store.dispatch('setUsuarioLogado', null);
                this.$router.push({ name: 'manutencao' });
            } else {
                authService.setSessionLocale();
                Temas.aplicarTema(data.tema);

                document.title = data.logoUrl ? 'Parceria Sustentável' : 'Lyra';
                const link = document.querySelector("[rel='icon']");
                link.setAttribute(
                    'href',
                    data.faviconUrl
                        ? data.faviconUrl
                        : '/lyra-favicon/favicon3.ico'
                );

                if (data.isLaudo) {
                    data.authorities = data.authorities.map(item => {
                        if (item.authority === 'ROLE_FEATURE_LAUDO') {
                            return item;
                        }
                    });
                    data.authorities = data.authorities.filter(
                        item => item !== undefined
                    );
                    data.preAnaliseCreditoAccess = false;
                    data.sentinelHubAccess = false;
                    data.monitoramentoSocioambientalAccess = false;
                    data.monitoramentoAgricolaAccess = false;
                    store.dispatch('setUsuarioIsLaudo', true);
                }

                await controleAcesso
                    .buscarPermissoesMenuFeature(data)
                    .then(resultado => {
                        if (data.isLaudo && data.isAdmin) {
                            resultado = resultado.filter(
                                item =>
                                    item.name === 'BotaoHome' ||
                                    item.name === 'BotaoLaudos' ||
                                    item.name === 'BotaoUsuarios'
                            );
                        } else if (data.isLaudo && !data.isAdmin) {
                            resultado = resultado.filter(
                                item =>
                                    item.name === 'BotaoHome' ||
                                    item.name === 'BotaoLaudos'
                            );
                        }
                        this.atualizarBotoes += 1;
                        this.botoes = resultado;
                    });

                if (data.isAnalyst) {
                    this.$router.push({ name: 'Laudos' });
                }

                // Inicializar WebSocket após carregar dados do usuário
                this.$nextTick(() => {
                    this.initWebSocket();
                });
            }
        },
        reloadLaudoRenovabio() {
            if (window.location.href.includes('renovabio')) {
                window.location.reload();
            }
        },
        updateGrupoSelecionado() {
            this.buscarDadosUsuarioLogado();
        },

        /**
         * Inicializa conexão WebSocket para notificações em tempo real
         */
        async initWebSocket() {
            try {
                // Verificar se já foi inicializado
                if (this.webSocketInitialized) {
                    return;
                }

                // Verificar se usuário está autenticado
                if (!this.usuarioLogado) {
                    return;
                }

                const userId = this.usuarioLogado.idKeyCloack;

                if (userId) {
                    // Conectar ao WebSocket usando o utilitário global
                    await connect();

                    // Inscrever no tópico de notificações de relatórios
                    subscribeReports(userId);
                    
                    // Inscrever no tópico de notificações genéricas
                    subscribeNotifications(userId);

                    this.webSocketInitialized = true;
                }
            } catch (error) {
                // Erro ao inicializar WebSocket - log suprimido
            }
        }
    },
    watch: {
        // Reconectar WebSocket quando usuário logar
        usuarioLogado(newValue, oldValue) {
            if (newValue && !oldValue) {
                this.webSocketInitialized = false;
                this.initWebSocket();
            } else if (!newValue && oldValue) {
                disconnect();
                this.webSocketInitialized = false;
            }
        }
    }
};
</script>

<style lang="scss">
#app {
    height: 100vh;
    width: 100vw;
    overflow: hidden;

    .conteudo-central {
        height: calc(100vh - 65px);
        width: calc(100vw - 70px);
        margin-top: 65px;
        margin-left: 70px;
        overflow-y: auto;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: var(--primary);
        border-radius: 10px;
        border: 1px solid var(--white);
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }

    @media (max-width: 1370px) {
        Footer#lyra-rodape {
            padding-top: 80px;
            margin: 0;

            p {
                width: 100%;
                text-align: center;
                margin-bottom: 0;
                margin-left: 70px;
            }
        }
    }
}
</style>
